import React from 'react';
import FeedComponent from 'components/FeedComponent';

const FeedPage = () => {
  return <FeedComponent />;
};

export default FeedPage;
